import { render } from "./Menu.vue?vue&type=template&id=9d7cc5d6"
import script from "./Menu.vue?vue&type=script&scoped=true&lang=js"
export * from "./Menu.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__